export default "__VITE_ASSET__CiCbu8Kx__"